import { Component, Input, ViewEncapsulation } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SewHeadline, SewTabBar, SewTabBarItem } from '@sew/ui-components-angular/standalone';

@Component({
    selector: 'ecs-part-detail-description',
    templateUrl: './part-detail-description.component.html',
    styleUrls: ['./part-detail-description.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [TranslatePipe, SewTabBar, SewTabBarItem, SewHeadline],
})
export class PartDetailDescriptionComponent {
    @Input() public html?: string;
}
